<div class="row">
  <div class="col-12">
    <div class="card cds-card-shadow">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
              <li [ngbNavItem]="1">
                <button ngbNavLink>Authorization</button>
                <ng-template ngbNavContent>
                  <appspinner [startSpinner]="showAppLoader"></appspinner>
                  @if (isError && errorMessage) {
                    <div class="alert cds-alert alert-danger" role="alert">
                      <div class="cds-alert-icon">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                      </div>
                      <div class="cds-alert-content">
                        {{ errorMessage | translate }}
                      </div>
                    </div>
                  }
                  <div class="row p-2">
                    <div class="col-4">
                      <label class="form-label">{{ "User" | translate }}</label>
                      <ng-select
                        (change)="loadPermisions(selected)"
                        placeholder="{{ 'User' | translate }}"
                        [(ngModel)]="selected"
                        [clearable]="true"
                      >
                        @for (group of userGroups; track group) {
                          <ng-option [disabled]="true" [value]="group">
                            <img
                              src="{{ group.imgPath }}"
                              alt="userGroup"
                              style="width: 20px; height: 20px"
                            />
                            {{ group.viewValue }}
                          </ng-option>
                          @for (
                            username of group.grpUserNames;
                            track username
                          ) {
                            <ng-option [value]="username">
                              <img
                                class="pl-2"
                                src="{{ group.imgPath }}"
                                alt="userGroup"
                                style="
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                              />
                              {{ username.viewValue | translate }}
                            </ng-option>
                          }
                        }
                      </ng-select>
                    </div>
                    <div class="col-5 mt-4">
                      <button
                        [disabled]="showAppLoader || isEnableSave2DB"
                        type="button"
                        class="btn btn-sm btn-primary mt-2 m-1"
                        (click)="saveToDb()"
                      >
                        <i
                          class="fa fa-save"
                          title="{{ 'Save authorizations' | translate }}"
                        ></i>
                      </button>
                      <div
                        class="btn-group me-3 d-inline mt-2 overflow-hidden rounded-pill"
                      >
                        <button
                          type="button"
                          class="btn btn-primary btn-sm mt-2 rounded-end"
                          [disabled]="showAppLoader || isEnableSave2DB"
                          (click)="exporUserToXlsx()"
                        >
                          <i class="fa fa-print" title="Print User"></i>
                        </button>
                        <div
                          class="btn-group dropdown rounded-0"
                          ngbDropdown
                          role="group"
                          aria-label="Button group with nested dropdown"
                        >
                          <button
                            type="button"
                            (click)="openDialog(userSelectModal)"
                            class="btn btn-primary btn-sm mt-2 border-start dropdown-toggle dropdown-toggle-split mt-2 rounded-start"
                            ngbDropdownToggle
                            aria-label="Toggle Dropdown"
                          ></button>
                          <div
                            class="dropdown-menu"
                            hidden
                            ngbDropdownMenu
                          ></div>
                        </div>
                      </div>
                    </div>
                    @if (files1) {
                      <div class="col-12 mt-4">
                        <div class="col-md-12">
                          <p-treeTable
                            [value]="files1"
                            [columns]="cols"
                            selectionMode="single"
                            [(selection)]="selectedNode2"
                            dataKey="name"
                            (onNodeUnselect)="nodeUnselect($event)"
                            [resizableColumns]="true"
                          >
                            <ng-template pTemplate="colgroup" let-columns>
                              <colgroup>
                                @for (col of columns; track col) {
                                  <col />
                                }
                              </colgroup>
                            </ng-template>
                            <ng-template pTemplate="header" let-columns>
                              <tr
                                #header
                                style="
                                  border-bottom: 2px solid #003671;
                                  color: #003671;
                                "
                              >
                                <th
                                  scope="col"
                                  ttResizableColumn
                                  style="width: 50%"
                                  class="p-2"
                                >
                                  {{ "Explorer" | translate }}
                                </th>
                                <th
                                  scope="col"
                                  ttResizableColumn
                                  style="width: 10%; text-align: center"
                                  class="p-2"
                                >
                                  {{ "Enable" | translate }}
                                </th>
                                <th
                                  scope="col"
                                  ttResizableColumn
                                  style="width: 40%"
                                  class="p-2"
                                >
                                  {{ "Assigned Profile" | translate }}
                                </th>
                              </tr>
                            </ng-template>
                            <ng-template
                              pTemplate="body"
                              let-rowNode
                              let-rowData="rowData"
                              let-columns="columns"
                            >
                              @if (
                                !(
                                  rowData.type === "process" &&
                                  selectedUser.userRole === 5
                                )
                              ) {
                                <tr
                                  [ttRow]="rowNode"
                                  [ttSelectableRow]="rowNode"
                                  style="border-bottom: 1px solid #dddddd"
                                >
                                  <td style="width: 50%" class="p-2">
                                    <p-treeTableToggler
                                      [rowNode]="rowNode"
                                    ></p-treeTableToggler>
                                    @if (rowData.type == "installation") {
                                      <img
                                        src="assets/img/icon-coloured-installation.svg"
                                        alt="installation"
                                        style="width: 20px; height: 20px"
                                      />
                                    }
                                    @if (rowData.type == "group") {
                                      <img
                                        src="assets/img/icon-coloured-group.svg"
                                        alt="group"
                                        style="width: 20px; height: 20px"
                                      />
                                    }
                                    @if (rowData.type == "institute") {
                                      <img
                                        src="assets/img/icon-coloured-organization.svg"
                                        alt="institute"
                                        style="width: 20px; height: 20px"
                                      />
                                    }
                                    @if (rowData.type == "process") {
                                      <img
                                        src="assets/img/icon-coloured-process.svg"
                                        alt="process"
                                        style="width: 20px; height: 20px"
                                      />
                                    }
                                    {{ rowData.name }}
                                  </td>
                                  <td
                                    style="width: 10%; text-align: center"
                                    class="p-2"
                                  >
                                    @if (
                                      rowData.parentId !== 0 ||
                                      (rowData.parentId === 0 &&
                                        selectedUser.userRole === 5)
                                    ) {
                                      <input
                                        [disabled]="showAppLoader"
                                        id="checkbox3"
                                        class="form-check-input"
                                        type="checkbox"
                                        [(ngModel)]="rowData.enabled"
                                        [indeterminate]="rowData.indeterminate"
                                        (click)="nodeSelect(rowNode, template)"
                                      />
                                    }
                                  </td>
                                  <td style="width: 40%" class="p-2">
                                    {{
                                      displayAssignedProfileValue(
                                        rowData.userProfileId
                                      )
                                    }}
                                  </td>
                                </tr>
                              }
                            </ng-template>
                          </p-treeTable>
                        </div>
                      </div>
                    }
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2">
                <button ngbNavLink>Profiles</button>
                <ng-template ngbNavContent>
                  <div class="row">
                    <div class="col-12">
                      <input
                        class="form-control mb-3"
                        placeholder="{{ 'Quick Filter' | translate }}"
                        [(ngModel)]="searchText"
                      />
                      <appspinner [startSpinner]="showAppLoader"></appspinner>
                    </div>
                    <div class="col-12">
                      <table
                        aria-describedby="table-userPermission"
                        class="table table-striped"
                        [mfData]="
                          userProfiles | filter: 'name,description' : searchText
                        "
                        mfSortBy="name"
                        #mf="mfDataTable"
                        [mfRowsOnPage]="15"
                      >
                        <thead>
                          <tr>
                            <th class="center-align">
                              <mfDefaultSorter by="name">{{
                                "Name" | translate
                              }}</mfDefaultSorter>
                            </th>
                            <th>
                              <mfDefaultSorter by="description"
                                >{{ "Description" | translate }}
                              </mfDefaultSorter>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (userprofile of mf.data; track userprofile) {
                            <tr>
                              <td class="center-align">
                                {{ userprofile.name }}
                              </td>
                              <td>{{ userprofile.description | translate }}</td>
                            </tr>
                          }
                        </tbody>
                        @if (
                          (
                            userProfiles
                            | filter: "name,description" : searchText
                          ).length > 15
                        ) {
                          <tfoot>
                            <tr>
                              <td colspan="10">
                                <mfBootstrapPaginator
                                  [rowsOnPageSet]="[15, 50, 100]"
                                ></mfBootstrapPaginator>
                              </td>
                            </tr>
                          </tfoot>
                        }
                      </table>
                      @if (!showAppLoader && userProfiles.length === 0) {
                        <div class="alert cds-alert alert-danger" role="alert">
                          <div class="cds-alert-icon">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                          </div>
                          <div class="cds-alert-content">
                            {{ "No records found." | translate }}
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>

            <div [ngbNavOutlet]="nav" class="mt-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #template tabindex="-1" class="modal fade cds-modal" let-modal>
  <div class="modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>{{ modalTitle | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          (click)="modal.dismiss()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-4">
            <label class="form-label">{{ "Node Code" | translate }}</label>
            <input
              type="text"
              placeholder="{{ 'Node Code' | translate }}"
              class="form-control"
              value="{{ selectedNode.data.name }}"
              [disabled]="true"
            />
          </div>
          <div class="col-2 mt-4">
            <input
              class="form-check-input mt-4"
              type="checkbox"
              [(ngModel)]="enabled"
              (ngModelChange)="enable()"
            />
            <label class="form-check-label mt-3 p-1">{{
              "Enable" | translate
            }}</label>
          </div>
          @if (enabled && selectedNode.data.type == "process") {
            <div class="col-6">
              <label class="form-label">{{
                "Assigned Profile" | translate
              }}</label>
              <ng-select
                placeholder="{{ 'Assigned Profile' | translate }}"
                [(ngModel)]="userRole"
                (ngModelChange)="
                  displayAssignedProfileValue(
                    userRole.id.id,
                    userRole.description,
                    userRole
                  );
                  enable()
                "
              >
                @for (profile of userProfiles; track profile) {
                  <ng-option [value]="profile">
                    {{ profile.name }}
                    <!-- {{displayAssignedProfileValue(profile.id.id, profile.description,profile)}} -->
                  </ng-option>
                }
              </ng-select>
            </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <button
          [disabled]="isDisableSave"
          type="submit"
          class="btn btn-primary"
          (click)="save()"
        >
          {{ "Save" | translate }}
        </button>
        <button type="button" class="btn btn-default" (click)="decline()">
          {{ "Close" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template
  #userSelectModal
  tabindex="-1"
  class="modal fade cds-modal"
  let-modal
>
  <div class="modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>Print Users</h5>

        <button
          type="button"
          class="btn-close"
          (click)="modal.dismiss(); resetAllCheckboxes()"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="col-12">
          {{ searchText }}
          <table
            aria-describedby="table-selectedUsersPermission"
            class="table table-striped"
            [mfData]="
              userNames | filter: 'viewValue' : searchText | roleFilter: [1, 5]
            "
            #mf="mfDataTable"
            [mfRowsOnPage]="15"
          >
            <thead>
              <tr>
                <th class="text-center">
                  <input
                    id="checkbox"
                    class="form-check-input hidden"
                    type="checkbox"
                    [checked]="isAllChecked"
                    (click)="selectAll(userNames)"
                    [disabled]="isLoading"
                  />
                </th>
                <th>
                  <mfDefaultSorter by="description"
                    >Users List
                  </mfDefaultSorter>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (user of mf.data; let i = $index; track user) {
                <tr>
                  <td
                    class="center-align text-nowrap"
                    style="width: 10%; text-align: center"
                    class="p-2"
                  >
                    <input
                      id="{{ user.viewValue }}"
                      class="form-check-input"
                      [checked]="userSelected(user)"
                      type="checkbox"
                      (click)="utenteSelezionatoCheckbox1(user)"
                      [disabled]="isLoading"
                    />
                  </td>
                  <td class="center-align">{{ user.viewValue }}</td>
                </tr>
              }
            </tbody>
            @if (
              (
                s1userInfoArray.s1UserInfo
                | filter: "name,description" : searchText
              ).length > 15
            ) {
              <tfoot>
                <tr>
                  <td colspan="10">
                    <mfBootstrapPaginator
                      [rowsOnPageSet]="[15, 50, 100]"
                    ></mfBootstrapPaginator>
                  </td>
                </tr>
              </tfoot>
            }
          </table>
          @if (!showAppLoader && userProfiles.length === 0) {
            <div class="alert cds-alert alert-danger" role="alert">
              <div class="cds-alert-icon">
                <i class="fa-solid fa-triangle-exclamation"></i>
              </div>
              <div class="cds-alert-content">
                {{ "No records found." | translate }}
              </div>
            </div>
          }
        </div>
      </div>
      <div class="modal-footer">
        <!--  <button  type="submit" class="btn btn-sm  btn-primary" [disabled]="isLoading" (click)="exportUserToXlsxFromModal();resetAllCheckboxes()"> -->
        <button
          type="submit"
          class="btn btn-sm btn-primary"
          [disabled]="isLoading"
          (click)="
            downloadUtenti($event, this.listaUtenti); resetAllCheckboxes()
          "
        >
          @if (!isLoading) {
            <span>Print</span>
          }
          @if (isLoading) {
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          }
        </button>
        <button
          type="button"
          class="btn btn-sm btn-light m-b-0"
          (click)="modal.dismiss(); resetAllCheckboxes()"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
